// Vendor
import * as React from 'react';
import { BarItemProps } from '@nivo/bar';
import {
  SPOT_GREY_7,
  SPOT_WHITE
} from '@thredup/styleguide/src/variables/colors';

const Bar: React.FC<BarItemProps> = (props) => {
  const { data, color, height, label, width, x, y } = props;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data: chartData, id } = data as any;
  const tradThrift = chartData['Traditional Thrift & Donation'];
  const isResale = id === 'Resale';
  const isFastFashion = id === 'Fast Fashion';
  const isTradThrift = id === 'Traditional Thrift & Donation';
  const nonResaleX = isFastFashion ? x + -20 : x - 40;
  const translateX = isResale ? x + 5 : nonResaleX;
  const translateY = isResale ? y - tradThrift * 5 : y;
  const newWidth = width + 20;
  if (Number(label) === 0) return null;

  return (
    <g transform={`translate(${translateX}, ${translateY})`}>
      <rect
        fill={color}
        height={height}
        stroke="white"
        strokeWidth="0"
        width={newWidth}
      />
      <text
        className="font-bold text-sm"
        dominantBaseline="central"
        fill={isTradThrift ? SPOT_WHITE : SPOT_GREY_7}
        textAnchor="middle"
        x={newWidth / 2}
        y={height / 2}
      >
        {`$${label}B`}
      </text>
    </g>
  );
};

export { Bar };
